module.exports = __webpack_public_path__ + "static/media/twitter.7db1e7d8.svg";